import {UPDATE_SEARCH_RESULTS} from '../actions/ActionTypes';
import Config from '../../utils/Configuration';

const updateSearchResults = (state, payload) => {
    const searchResults = {all: {numFound: (payload.collection && payload.collection.matches) || '0'}};
    payload.collection &&
        payload.collection.groups &&
        payload.collection.groups.forEach((group) => {
            searchResults[group.groupValue] = group.doclist;
        });

    const updatedState = {
        ...searchResults,
        spellCheck: payload.spellCheck
    };

    sessionStorage.setItem(Config.sliceKey.searchResults, JSON.stringify(updatedState));
    return updatedState;
};

const reducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_SEARCH_RESULTS: {
            return updateSearchResults(state, action.payload);
        }
        default:
            return state;
    }
};

export default reducer;
